<ng-container *ngIf="state$ | async as state">
  <ng-container *ngIf="state.accounts !== null; else loadingState">
    <div class="activation-list" *ngIf="state.accounts.length > 0; else emptyState">
      <ng-container *ngFor="let account of state.accounts">
        <div class="account-data">{{ account.accountData.companyName }} ({{ account.businessId }})</div>
        <ng-container *ngFor="let activation of account.activations">
          <div
            class="activation-data"
            *ngIf="activation.activationStatus === ActivationStatus.ACTIVATION_STATUS_PENDING_ACTIVATION"
          >
            <ng-container *ngIf="state.productData.get(activation.addonId ?? activation.appId) as product">
              <div class="product-data">
                <glxy-avatar [src]="product.icon"></glxy-avatar>
                <div class="product-name">
                  <span>{{ product.name }}</span>
                  <span>{{ product.appId }}</span>
                </div>
              </div>
              <div class="activation-buttons">
                <button
                  mat-button
                  color="primary"
                  (click)="viewOrderForm(account, activation)"
                  [disabled]="state.isResponding || state.isLoading"
                  *ngIf="activation.orderFormSubmissionId"
                >
                  View order form
                </button>
                <button
                  mat-stroked-button
                  (click)="rejectActivation(account, activation, product)"
                  [disabled]="state.isResponding || state.isLoading"
                >
                  Reject
                </button>
                <button
                  mat-flat-button
                  color="primary"
                  (click)="approveActivation(account, activation, product)"
                  [disabled]="state.isResponding || state.isLoading"
                >
                  Approve
                </button>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="state.hasMore">
        <div class="load-button-container">
          <ng-container *ngIf="!state.isLoading; else buttonLoading">
            <button mat-button color="primary" class="load-more-button" (click)="loadMore()">
              Load more
              <mat-icon>add</mat-icon>
            </button>
          </ng-container>
          <ng-template #buttonLoading>
            <button mat-button color="primary" class="load-more-button">
              <glxy-loading-spinner size="small"></glxy-loading-spinner>
            </button>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
<ng-template #emptyState>
  <glxy-empty-state class="empty-state">
    <glxy-empty-state-title>No pending activations</glxy-empty-state-title>
    <p>Activations that require your approval will show up here</p>
  </glxy-empty-state>
</ng-template>
<ng-template #loadingState>
  <div class="loading-state">
    <glxy-loading-spinner class="loading-spinner" size="large" fullHeight fullWidth></glxy-loading-spinner>
  </div>
</ng-template>
